module.exports = __webpack_public_path__ + "c8a23766ffcc2be5359d02e89b5b973c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/photo.svg
// module id = 773
// module chunks = 0